define('src/interface',['src/errors'], function(Errors) {
    return {
        NotImplemented: function() {
            throw new Errors.NotImplementedError("This method is part of an abstract interface and should be implemented, but it was not");
        },
    };
});

